import { faker } from '@faker-js/faker';

function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const highlightMatches = (label: string, searchValue: string) => {
  if (!searchValue || !label) {
    return label;
  }

  const escapedSearchValue = escapeRegExp(searchValue);
  const regex = new RegExp(`(${escapedSearchValue})`, 'gi');
  const parts = label.split(regex);

  return parts.map((part: string) => {
    if (regex.test(part)) {
      return (
        <span key={faker.string.uuid()} className='text-vividTangelo'>
          {part}
        </span>
      );
    }
    return part;
  });
};
